import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AbstractVisbosComponent} from '../../../../core/visbos-core/components/abstract-visbos.component';
import {MovingDirection, WizardComponent} from 'ng2-archwizard/dist';
import {SessionActions} from '../../../../shared/actions';
import {ActivatedRoute, Router} from '@angular/router';
import {LocationMarriageWizardService} from '../../services/location-marriage-wizard.service';
import {ILocation} from '../../../../shared/view-model/ilocation.interface';

@Component({
  selector: 'vb-location-marriage-wizard',
  templateUrl: './location-marriage-wizard.component.html',
  styleUrls: ['./location-marriage-wizard.component.css'],
  providers: [LocationMarriageWizardService]
})
export class LocationMarriageWizardComponent extends AbstractVisbosComponent implements OnInit, AfterViewInit, OnDestroy {

  MovingDirection;

  @ViewChild(WizardComponent)
  wizard: WizardComponent;

  currentStep: number;

  canExitLocationPageProxy = (direction: MovingDirection) => this.canExitPackingPage.apply(this, [direction]);
  canExitItemsPageProxy = (direction: MovingDirection) => this.canExitItemsPage.apply(this, [direction]);

  private isSaved: boolean = false;


  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private router: Router, private activatedRoute: ActivatedRoute,
              public wizardService: LocationMarriageWizardService) {
    super(sessionActions, cd);

    this.MovingDirection = MovingDirection;

  }

  onStepChanged() {
    let step = this.wizard.model.getIndexOfStep(this.wizard.model.currentStep);
    this.currentStep = step;
    this.cd.detectChanges();
  }

  onFinalStepEntered() {
    this.onStepChanged();
    this.wizardService.assignLocationToAssets().subscribe(
      res => {
        this.sessionActions.pushMessage("Der neue Standort wurde erfolgreich zugewiesen.");
        this.gotoStart();
      }, err => {
        this.sessionActions.throwError(err, "Fehler beim Zuweisen des Standorts!");
      }
    );
  }

  canExitPackingPage(direction: MovingDirection): boolean {

    if (direction == MovingDirection.Forwards) {
      if (this.wizardService.currentLocation) {
        return true;
      }
    }

    return false;
  }

  canExitItemsPage(direction: MovingDirection): boolean {

    if (direction == MovingDirection.Forwards) {
      if (this.wizardService.currentAssetTree && this.wizardService.currentAssetTree.length) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }

  }

  gotoStart() {
    this.wizardService.resetWizard();
    this.wizard.navigation.reset();
  }

  onLocationChange(location: ILocation) {
    this.wizardService.currentLocation = location;
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/asset-management/components/location-marriage-wizard/location-marriage-wizard.component.ts